import FormData from 'form-data';
import { put } from 'redux-saga/effects';
import { apiImageUpload, apiPost } from 'shared/api';
import * as actions from 'store/actions';

export function* uploadPostImageSaga(action) {
  yield put(actions.uploadPostImageStart());
  console.log('uploadPostImageSaga');
  try {
    const imageFormData = yield new FormData();
    yield imageFormData.set('Image', action.Image);
    yield imageFormData.set('Type', action.Type);
    if (action.SizeTo) yield imageFormData.set('SizeTo', action.SizeTo);
    const response = yield apiImageUpload('v2_postFileUpload', imageFormData);
    if (response.data.payload) {
      const postImageResponse = yield response.data.payload.Files[0];
      yield put(actions.uploadPostImageSuccess(postImageResponse, action.Type, action.CommentType));
    } else {
      yield put(actions.uploadPostImageFailed(response.data));
    }
  } catch (error) {
    yield put(actions.uploadPostImageFailed(error.message));
  }
}

export function* initPostFormSaga(action) {
  if (action.isDraft === true) yield put(actions.fetchPost(action.PostId, null, null, true, action.UserId, action.isManagedUser));
  yield put(actions.initPostForm(action.PostId, action.isDraft, action.isGift, action.redirectPath));
}

export function* addPostSaga(action) {
  yield put(actions.addPostStart());
  try {
    const data = {
      Name: action.Name ? action.Name : '',
      Type: action.ContentType ? action.ContentType : 'Other',
      DateStart: action.DateStart ? action.DateStart : 'NULL',
    };
    if (action.Desc) {
      data.Desc = action.Desc;
    }
    if (action.LogIds) {
      data.LogId = action.LogIds.toString();
    }
    if (action.DateEnd) {
      data.DateEnd = action.DateEnd;
    }
    if (action.TimeStart) {
      data.TimeStart = action.TimeStart;
    }
    if (action.TimeEnd) {
      data.TimeEnd = action.TimeEnd;
    }
    if (action.WhatTags) {
      data.WhatTags = action.WhatTags.toString();
    }
    if (action.WhoTags) {
      data.WhoTags = action.WhoTags.toString();
    }
    if (action.LocationTags) {
      data.LocationTags = action.LocationTags.toString();
    }
    if (action.AddFileIds) {
      data.AddFileIds = action.AddFileIds.toString();
    }
    if (action.RemovedImageIds) {
      data.DeleteFileIds = action.RemovedImageIds.toString();
    }
    if (action.SendToUserId) {
      data.SendToUserId = action.SendToUserId.toString();
    }
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    if (action.Ongoing) {
      data.Ongoing = action.Ongoing;
    }
    data.Location = action.Location !== null && action.Location !== undefined ? action.Location : 'NULL';
    data.Location2 = action.Location2 ? action.Location2 : 'NULL';
    data.LocIcon = action.LocIcon ? action.LocIcon : 'NULL';
    data.LocFav = action.LocFav ? action.LocFav : false;
    data.FavId = action.FavId ? action.FavId : 'NULL';
    data.MapType = action.MapType ? action.MapType : 'NULL';
    data.Pitch = action.Pitch ? action.Pitch : 'NULL';
    data.Heading = action.Heading ? action.Heading : 'NULL';
    if (action.Center) {
      data.MapLat = action.Center.lat;
      data.MapLng = action.Center.lng;
    }
    if (action.GeoLocation) {
      data.Lat = action.GeoLocation.lat;
      data.Lng = action.GeoLocation.lng;
    }
    data.Zoom = action.Zoom ? action.Zoom : 'NULL';
    if (action.PostType === 'Draft') {
      if (action.MessageToUser) {
        data.MessageToUser = action.MessageToUser;
      }
      if (action.SaveCopyForSelf) {
        data.SaveCopyForSelf = action.SaveCopyForSelf;
      }
    }
    const apiEndPoint = action.PostType === 'Draft' ? 'v2_draftAdd' : 'v2_postAdd';
    console.log('Add post saga - apiEndPoint', apiEndPoint);
    console.log('addPostSaga - data: ', data);
    const response = yield apiPost(apiEndPoint, data);
    const isDraft = yield action.PostType === 'Draft';
    const isGift = yield !!(action.SendToUserId && action.SendToUserId.toString());

    yield put(actions.addPostSuccess(response.data.payload.PostId, isDraft, isGift));
    if (action.PostType !== 'Draft' && !isGift) {
      yield put(actions.fetchPost(response.data.payload.PostId, null, null, true, action.UserId, action.isManagedUser));
    }
  } catch (error) {
    yield put(actions.addPostFailed(error.response.data.error_message));
  }
}

export function* editPostSaga(action) {
  yield put(actions.editPostStart());
  try {
    const data = {
      PostId: action.EntryId,
      LogId: action.LogIds.toString(),
      Name: action.Name,
    };
    if (action.DateEnd !== null) {
      if (action.DateEnd === '') {
        data.DateEnd = 'NULL';
      } else {
        data.DateEnd = action.DateEnd;
      }
    }
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    if (action.Type) {
      data.Type = action.Type;
    }
    if (action.DateStart) {
      data.DateStart = action.DateStart;
    }
    if (action.Desc) {
      data.Desc = action.Desc;
    }
    if (action.TimeStart) {
      data.TimeStart = action.TimeStart;
    }
    if (action.TimeEnd) {
      data.TimeEnd = action.TimeEnd;
    }
    if (action.WhatTags) {
      data.WhatTags = action.WhatTags.toString();
    }
    if (action.WhoTags) {
      data.WhoTags = action.WhoTags.toString();
    }
    if (action.LocationTags) {
      data.LocationTags = action.LocationTags.toString();
    }
    if (action.AddFileIds) {
      data.AddFileIds = action.AddFileIds.toString();
    }
    if (action.DeleteFileIds) {
      data.DeleteFileIds = action.DeleteFileIds.toString();
    }
    if (action.Ongoing) {
      data.Ongoing = action.Ongoing;
    }
    if (action.Location !== null && action.Location !== undefined) {
      data.Location = action.Location;
    }
    if (action.Location2) {
      data.Location2 = action.Location2;
    }
    if (action.LocIcon) {
      data.LocIcon = action.LocIcon;
    }
    if (action.LocFav) {
      data.LocFav = action.LocFav;
    }
    if (action.FavId) {
      data.FavId = action.FavId;
    }
    if (action.MapType) {
      data.MapType = action.MapType;
    }
    if (action.Pitch) {
      data.Pitch = action.Pitch;
    }
    if (action.Heading) {
      data.Heading = action.Heading;
    }
    if (action.Center) {
      data.MapLat = action.Center.lat;
      data.MapLng = action.Center.lng;
    }
    if (action.GeoLocation) {
      data.Lat = action.GeoLocation.lat;
      data.Lng = action.GeoLocation.lng;
    }
    if (action.Zoom) {
      data.Zoom = action.Zoom;
    }
    if (action.PostType) {
      data.PostType = action.PostType;
    }
    yield apiPost('v2_postUpdate', data);

    yield put(actions.editPostSuccess());
    if (action.PostType === 'Draft') {
      yield put(actions.fetchDrafts());
    }
  } catch (error) {
    yield put(actions.editPostFailed(error.response.data.error_message));
  }
}

export function* addCommentImageToPostSaga(action) {
  yield put(actions.addCommentImageToPostStart());
  try {
    const data = {
      PostId: action.PostId,
      CopyCommentFileIds: action.CommentImageId,
    };
    yield apiPost('v2_postUpdate', data);
    yield put(actions.addCommentImageToPostSuccess());
  } catch (error) {
    yield put(actions.addCommentImageToPostFailed(error.response.data.error_message));
  }
}

export function* fetchPostSaga(action) {
  yield put(actions.fetchPostStart());
  try {
    const data = { PostId: action.PostId, AdminOverride: true };
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    if (action.RoomId) {
      data.RoomId = action.RoomId;
    }
    const apiEndPoint = action.isDraft ? 'v2_draftDetails' : 'v4_postDetails';
    const response = yield apiPost(apiEndPoint, data);
    const post = action.isDraft ? response.data.payload.Post : response.data.payload;
    yield put(actions.fetchPostSuccess(post, response.data.payload.Rooms));
  } catch (error) {
    yield put(actions.fetchPostFailed(error.response.data.error_message));
  }
}

export function* duplicatePostSaga(action) {
  yield put(actions.duplicatePostStart());
  try {
    const apiEndPoint = action.isDraft ? 'v2_draftDetails' : 'v3_postDetails';
    const response = yield apiPost(apiEndPoint, { PostId: action.PostId, AdminOverride: true });
    const post = yield response.data.payload.Post;
    const fileIds = yield post.Files.Files.length > 0 ? post.Files.Files.map((file) => file.Id) : null;
    const postTitle = yield action.copyNumber ? `${post.Post.Name} — ${action.copyNumber}` : post.Post.Name;
    yield put(
      actions.addPost(
        post.Post.UserId,
        false,
        [],
        postTitle,
        post.Post.Type,
        post.Post.DateStartCalc,
        post.Post.DateEndCalc,
        post.Post.TimeStartCalc,
        post.Post.TimeEndCalc,
        post.Post.Desc,
        fileIds,
        [],
        post.Tags.WhatTags,
        post.Tags.WhoTags,
        post.Tags.LocationTags,
        post.Post.Ongoing,
        post.Post.Location,
        post.Post.Location2,
        post.Post.LocIcon,
        post.Post.LocFav,
        post.Post.FavId,
        post.Post.MapType,
        { lat: post.Post.MapLat, lng: post.Post.MapLng },
        { lat: post.Post.Lat, lng: post.Post.Lng },
        post.Post.Pitch,
        post.Post.Heading,
        post.Post.Zoom,
        true,
      ),
    );
    yield put(actions.duplicatePostSuccess());
  } catch (error) {
    yield put(actions.duplicatePostFailed(error.response.data.error_message));
  }
}

export function* deletePostSaga(action) {
  yield put(actions.deletePostStart());
  try {
    const data = { PostId: action.postId, Delete: true };
    if (action.isManagedUser) {
      data.UserId = action.UserId;
    }
    yield apiPost('v2_postUpdate', data);
    yield put(actions.deletePostSuccess());
  } catch (error) {
    yield put(actions.deletePostFailed(error.response.data.error_message));
  }
}

export function* submitPostCommentSaga(action) {
  yield put(actions.submitPostCommentStart());
  try {
    const data = {
      PostId: action.PostId,
      LogId: action.LogId,
    };
    if (action.Comment) {
      data.Comment = action.Comment;
    }
    if (action.CommentImageId) {
      data.CommentImageId = action.CommentImageId.toString();
    }
    if (action.ParentCommentId) {
      data.ParentCommentId = action.ParentCommentId;
    }
    if (action.RoomId) {
      data.RoomId = action.RoomId;
    }
    if (action.WhoTags) {
      data.WhoTags = action.WhoTags.toString();
    }
    if (action.WhatTags) {
      data.WhatTags = action.WhatTags.toString();
    }
    if (action.LocationTags) {
      data.LocationTags = action.LocationTags.toString();
    }
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    yield apiPost('v2_postCommentAdd', data);
    yield put(actions.submitPostCommentSuccess());
  } catch (error) {
    yield put(actions.submitPostCommentFailed(error.response.data.error_message));
  }
}

export function* entryCommentUpdateSaga(action) {
  yield put(actions.entryCommentUpdateStart());
  try {
    const data = {
      CommentId: action.CommentId,
    };
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    if (action.Comment) {
      data.Comment = action.Comment;
    }
    if (action.Delete) {
      data.Delete = action.Delete;
    }
    if (action.CommentImageId) {
      data.CommentImageId = action.CommentImageId.toString();
    }
    if (action.WhoTags !== null && action.WhoTags !== undefined) {
      data.WhoTags = action.WhoTags.toString();
    }
    if (action.WhatTags !== null && action.WhatTags !== undefined) {
      data.WhatTags = action.WhatTags.toString();
    }
    if (action.LocationTags !== null && action.LocationTags !== undefined) {
      data.LocationTags = action.LocationTags.toString();
    }
    if (action.isManagedUser === true) {
      data.UserId = action.UserId;
    }
    yield apiPost('v2_postCommentUpdate', data);
    yield put(actions.entryCommentUpdateSuccess());
  } catch (error) {
    yield put(actions.entryCommentUpdateFailed(error.response.data.error_message));
  }
}
